import { buildStoryOptions } from '../FilterBar/FilterBuilders/storyFilter'

export const sanitizeFilterTree = (filterTree) =>
  filterTree.filter((filter) => filter.title !== 'Live Date Range')

export const findStoryInFilterTree = (storyId, storyFilterTree = {}) => {
  if (
    storyId &&
    storyFilterTree &&
    storyFilterTree.childOptions &&
    storyFilterTree.childOptions.length
  ) {
    return storyFilterTree.childOptions.find(
      (option) =>
        option.id.toString() === storyId ||
        option.id.toString() === `story-${storyId}`
    )
  }

  return null
}

export const sanitizeValue = (values = [], storyFilterTree) => {
  const sanitizedValues = values.filter(
    (value) => !findStoryInFilterTree(value, storyFilterTree)
  )
  const valueWhitelist = ['duration_ends_at', 'duration_starts_at']

  return sanitizedValues.filter((key) => !valueWhitelist.includes(key))
}

export const addStoryFilter = (filterTree, stories, storyFilter) => {
  const noStories = stories && stories.length === 0
  if (noStories && !storyFilter) return filterTree

  const filterTreeClone = filterTree.slice()
  const storyFilterIndex = filterTree.findIndex(
    (filter) => filter.title === 'Stories'
  )

  if (storyFilterIndex === -1) {
    const storyFilterClone = { ...storyFilter }

    if (stories) {
      const storyOptions = buildStoryOptions(stories)
      storyFilterClone.childOptions = storyOptions
    }

    return [storyFilterClone, ...filterTreeClone]
  }

  if (stories) {
    const storyOptions = buildStoryOptions(stories)
    filterTreeClone[storyFilterIndex].childOptions = storyOptions
    return filterTreeClone
  }

  return filterTreeClone
}

export const addMomentFilter = (filterTree, momentFilter) => {
  const filterTreeClone = filterTree.slice()
  filterTreeClone.splice(1, 0, momentFilter)

  return filterTreeClone
    .filter((obj) => Object.keys(obj).length > 0)
    .filter(
      (obj, pos, arr) => arr.map((mapObj) => mapObj.id).indexOf(obj.id) === pos
    )
}

export const getFilterTree = (props, storyFilter, momentFilter) => {
  let preppedFilters
  const filterTree = props.filterProps?.filterTree || []

  let sortedStories = []
  if (props.stories) {
    sortedStories = props.stories.sort((a, b) => (a.name > b.name ? 1 : -1))
  }

  preppedFilters = sanitizeFilterTree(filterTree)
  preppedFilters = addStoryFilter(preppedFilters, sortedStories, storyFilter)
  if (momentFilter) {
    preppedFilters = addMomentFilter(preppedFilters, momentFilter)
  }

  return preppedFilters
}

export const getSelectedValues = (props, storyFilterTree) => {
  const value = (props.filterProps && props.filterProps.value) || []

  if (!props.currentStoryId) {
    return sanitizeValue(value, storyFilterTree)
  }

  const story = findStoryInFilterTree(props.currentStoryId, storyFilterTree)

  if (!story) {
    return sanitizeValue(value, storyFilterTree)
  }

  if (!value.includes(story.id)) {
    value.push(story.id)
  }

  return sanitizeValue(value)
}

export const contentFilterSieve = (enabledFilters) => {
  const filters = {
    accountIds: [],
    serviceIds: [],
    labelIds: [],
    postStatuses: [],
    storyIds: [],
  }

  enabledFilters.forEach((filter) => {
    // this is a hacky fix for the fact that
    // on initial load filters are passed from
    // backbone as strings, not objects
    if (!filter.payload.type_key) return

    switch (filter.payload.type_key) {
      case 'services_and_accounts':
        if (filter.payload.object.service_id) {
          filters.accountIds.push(filter.payload.object.id)
        } else {
          filters.serviceIds.push(
            filter.payload.object._id /* eslint no-underscore-dangle :off */
          )
        }
        break
      case 'labels':
        filters.labelIds.push(filter.payload.object.id)
        break
      case 'statuses':
        filters.postStatuses.push(filter.payload.object.status)
        break
      case 'stories':
        filters.storyIds.push(filter.payload.object.id)
        break
      default:
        break
    }
  })

  return filters
}
